import { IInitialState } from '../Interfaces'
import dayjs from 'dayjs';
// import utc from 'dayjs-plugin-utc';

// // Extend Day.js with UTC plugin
// dayjs.extend(utc);
export const initialState: IInitialState = {
    activities: {
        data: [],
        isLoading: false
    },
    parameters: {
        data: {},
        isLoading: false
    },
    userAndCase: {
        user: '',
        caseNumber: '',
        level:''
    },
    initailValue: {},
    isExecuteSuccess: false,
    activityDetail: {
        activityCode: '',
        activityGroup: '',
        activityGroupId: '',
        activityId: '',
        canExecute: false,
        categoryId: '',
        categoryName: '',
        description: '',
        displayName: '',
        entitytype: '',
        name: '',
        type: '',
        actionType: 'runActivity',
        activityHistoryId: '',
        executedStatus: '',
        scheduledTime: '',
        clickTime: 0
    },
    isPendingActivityExecuteSuccess: false,
    isPendingActivityNotAvailable: false,
    isRefreshRoutines: true,
    isExecuting:false
}